import React, { useState, useContext } from "react";
import PropTypes from "prop-types";

export const SidebarContext = React.createContext();

export const SidebarContextProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1200);
  const [isInFullscreen, setIsInFullscreen] = useState(false);
  const [isSidebarAvailable, setIsSidebarAvailable] = useState(false);

  window.addEventListener("resize", () => {
    // We always close the sidebar on mobile
    if (window.innerWidth < 1200) {
      setIsSidebarOpen(false);
    }
  });

  return (
    <SidebarContext.Provider
      value={{
        isSidebarOpen,
        setIsSidebarOpen,
        isInFullscreen,
        setIsInFullscreen,
        isSidebarAvailable,
        setIsSidebarAvailable
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);

SidebarContextProvider.propTypes = {
  children: PropTypes.node
};
